import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  "& .gathering-results": {
    height: "75vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  "& .feedback-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: "10px",
      alignItems: "flex-start",
    },
    "& .actions": {
      display: "flex",
      gap: "10px",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: "10px",
        width: "100%",
      },
    },
  },
  "& .grouped-content-row": {
    marginBottom: "20px",
    display: "flex",
    gap: "20px",
    "@media (max-width:1080px)": {
      flexDirection: "column",
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: "10px",
      width: "100%",
    },
    "& .border-card-heading button p": {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      "& span": {
        fontWeight: "600",
      },
    },
    "& > div:nth-of-type(1)": {
      width: "60%",
      flex: "0 0 60%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        flex: "0 0 100%",
      },
      "@media (max-width:1080px)": {
        width: "100%",
        flex: "0 0 100%",
      },
    },
    "& .recommendations": {
      "& h3": {
        margin: "0 0 20px 0",
        fontSize: "16px",
      },
      "& .actions": {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        [theme.breakpoints.down("md")]: {
          flexDirection: "column",
          gap: "10px",
          width: "100%",
        },
      },
      "& ul": {
        listStyle: "none",
        margin: "15px 0 20px 0",
        padding: "0",
        "& li": {
          marginBottom: "15px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          position: "relative",
          paddingLeft: "40px",
          fontWeight: 400,
          fontSize: "14px",
          "&:last-child": {
            marginBottom: 0,
          },
          "& .icon": {
            position: "absolute",
            left: "0",
            top: "0",
            borderRadius: "6px",
            background: "#211F45",
            width: "24px",
            height: "24px",
            textAlign: "center",
          },
          "& svg": {
            width: "15px",
            height: "8px",
          },
        },
      },
    },
    "& .progress-wheel": {
      maxWidth: "250px",
      margin: "0 auto",
      [theme.breakpoints.down("md")]: {
        maxWidth: "180px",
      },
      "& .progress-label": {
        textAlign: "center",
        fontWeight: "600",
        fontSize: "40px",
        lineHeight: "1.2",
        letterSpacing: "-2px",
        opacity: 1,
        [theme.breakpoints.down("md")]: {
          fontSize: "40px",
        },
        "& span": {
          fontWeight: "normal",
          display: "block",
          fontSize: "13px",
          letterSpacing: "0",
          opacity: ".7",
        },
      },
    },
    "& .scoring-factors": {
      marginTop: "20px",
      "& h3": {
        margin: "0 0 15px 0",
        fontWeight: "normal",
        textTransform: "uppercase",
        fontSize: "12px",
      },
      "& ul": {
        margin: "10px 0 0 0",
        padding: 0,
        listStyle: "none",
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        "& li": {
          display: "flex",
          gap: "10px",
          background: "#211F45",
          borderRadius: "8px",
          padding: "12px",
          justifyContent: "space-between",
          fontSize: "12px",
          alignItems: "center",
          flexDirection: "row",
          width: "calc((100% - 10px) / 2)",
          cursor: "help",
          "& > span": {
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
            "& > span": {
              color: "#A87EFF",
              fontSize: "16px",
            },
          },
          [theme.breakpoints.down("md")]: {
            width: "100%",
          },
        },
      },
    },
    "& .chart-results": {
      "& .key-explanation": {
        display: "flex",
        justifyContent: "space-between",
        gap: "30px",
        marginBottom: "20px",
        [theme.breakpoints.down("md")]: {
          flexDirection: "column",
        },
        "& > p": {
          fontSize: "14px",
          lineHeight: "1.3",
          margin: 0,
        },
        "& .key": {
          "& ul": {
            padding: 0,
            listStyle: "none",
            margin: 0,
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",

            "& li": {
              display: "flex",
              gap: "10px",
              width: "calc((100% - 10px) / 2)",
              fontWeight: "400",
              fontSize: "14px",
              alignItems: "center",
              color: "#D5D7DA",
              lineHeight: "1.2",
              "& span": {
                display: "inline-block",
                background: "#fff",
                borderRadius: "50%",
                width: "8px",
                height: "8px",
              },
              "&.os": {
                "& span": {
                  background: "#962EFF",
                },
              },
              "&.is": {
                "& span": {
                  background: "#00B2D6",
                },
              },
              "&.eq": {
                "& span": {
                  background: "#D1C7FF",
                },
              },
              "&.ifs": {
                "& span": {
                  background: "#D1C7FF",
                },
              },
            },
          },
        },
      },
      "& .chart-wrapper": {
        height: "300px",
      },
    },
    "& .transcript-features": {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    }
  },
  "& .avatar-unavailable": {
    position: "relative",
    width: "100%",
    maxWidth: "1350px",
    aspectRatio: "16 / 9",
    borderRadius: "12px",
    backgroundColor: "#231F20",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    gap: "20px",
    padding: "0 25px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "10px",
    },
    "& p": {
      fontSize: "20px",
      margin: 0,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
    },
    "& svg": {
      width: "60px",
      height: "60px",
      [theme.breakpoints.down("sm")]: {
        width: "40px",
        height: "40px",
      },
    },
  },
}));
